import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import SubscriptionCard from "./suncription-card";

import { SubscriptionPlan } from "models/subscription/subcription-plan";
import { GetSubscriptionPlans } from "api/tenant";
import { BrandingData } from "admin-portal/settings/branding";

const SubscriptionPage: React.FC = () => {
  document.title = "Subscription" + BrandingData.titleSuffix;
  const title = "Subscription";
  const pageTitle = "List";
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<SubscriptionPlan[]>([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    loadSubscription();
  }, []);
  const loadSubscription = async () => {
    setLoading(true);
    const res = await GetSubscriptionPlans();
    if (!(res?.status?.isError ?? false) && res?.data) {
      setData(res?.data ?? []);
      setTotal(res?.data?.length ?? 0);
    } else {
      setData([]);
      setTotal(0);
    }
    setLoading(false);
  };

  return (
    <React.Fragment>
      <section className="relative pb-32" id="pricing">
        <div className="container 2xl:max-w-[87.5rem] px-4 mx-auto">
          <div className="mx-auto text-center xl:max-w-3xl">
            <h1 className="mb-4 leading-normal capitalize">Subscription Plans</h1>
            <p className="text-lg text-slate-500 dark:text-zink-200">Manage features as needed</p>
          </div>

          <div className="grid grid-cols-1 mt-16 gap-x-5 md:grid-cols-2 xl:grid-cols-4">
            {data.map((item, index) => (
              <div key={`sub-${item?.id ?? ""}`}>
                <SubscriptionCard subscription={item}></SubscriptionCard>
              </div>
            ))}
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default SubscriptionPage;
